import EmptyStatesPreview from '../content/EmptyStatesPreview'
import LinkToCustomScriptDoc from '../links/LinkToCustomScriptDoc'
import {
  Artwork,
  LinkButton
} from '@eggplant/pattern-library'
import { HiPlus } from 'react-icons/hi'
import { LinkToAddCustomScript } from '@eggplant/routing'

const description = `Custom scripts allow you to run a file on the execution environment before a test config run. They can execute any necessary Git commands to prepare the system, initialize data, set the system to a known state, or integrate with other version control systems.

⚙️ Add a new custom script to enable it in test config > advanced settings`

const renderButton = () =>
  <LinkButton variant='primary'>
    <LinkToAddCustomScript>
      <HiPlus
        aria-hidden
        size='19.2px'
      />
      New custom script
    </LinkToAddCustomScript>
  </LinkButton>

const CustomScriptIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        action={renderButton()}
        description={description}
        icon={<Artwork.CustomScript />}
        renderLink={<LinkToCustomScriptDoc />}
        title='Custom scripts'
      />
    </div>
  </div>

export default CustomScriptIntro
